import { LANGUAGES } from "./constants";

export const field = {
  state: { type: null, size: null, options: {} },
  reducers: {
    set(state, payload) {
      return { ...state, ...payload };
    },
    setOptions(state, payload) {
      return { ...state, options: payload };
    },
  },
  effects: dispatch => ({
    async incrementAsync(payload, rootState) {
      await new Promise(resolve => setTimeout(resolve, 1000));
      dispatch.count.increment(payload);
    },
  }),
};
export const ui = {
  state: { language: LANGUAGES.en },
  reducers: {
    setLanguage(state, payload) {
      return { ...state, language: payload };
    },
  },
  effects: dispatch => ({}),
};
